import { render, staticRenderFns } from "./NineTable.vue?vue&type=template&id=6bcad9ef&"
import script from "./NineTable.vue?vue&type=script&lang=js&"
export * from "./NineTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports